// Venue code: letters, digits and '-', 4 to 10 characters, starting and ending with a letter or
// digit (e.g. JWCC-MUM), stored uppercase. Same rule as the backend.
export const VENUE_CODE_PATTERN = /^[A-Z0-9][A-Z0-9-]{2,8}[A-Z0-9]$/;
export const VENUE_CODE_MAX_LENGTH = 10;
export const VENUE_NAME_MAX_LENGTH = 100;
// Max count is stored as a Postgres INTEGER; same upper limit as the backend.
export const MAX_COUNT_LIMIT = 2147483647;
export const LOCATION_NAME_MAX_LENGTH = 60;
export const CONTACT_MAX_LENGTH = 20;

export const PAGE_SIZE_OPTIONS = [10, 25, 50];
export const DEFAULT_PAGE_SIZE = 10;

// Contact number: digits with optional +, spaces, brackets or dashes; 7 to 15 digits in all.
export const isValidContactNumber = (contactNumber) => {
    if (!/^\+?[0-9 ()-]{7,20}$/.test(contactNumber)) return false;
    const digitCount = contactNumber.replace(/\D/g, '').length;
    return digitCount >= 7 && digitCount <= 15;
};

export const toVenueCode = (value) => String(value ?? '').toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, VENUE_CODE_MAX_LENGTH);

export const LOCATION_TYPES = {
    country: { key: 'country', title: 'Countries', label: 'Country', listKey: 'countries' },
    state: { key: 'state', title: 'States', label: 'State', listKey: 'states' },
    city: { key: 'city', title: 'Cities', label: 'City', listKey: 'cities' },
};

// Bulk upload file types, in the order shown. A type is offered once the locations it needs exist;
// the columns of each type are in its downloadable format.
export const UPLOAD_TYPES = [
    // templateFile: name the downloaded format is saved as (same as the backend's file).
    { key: 'master', label: 'Master (all in one)', requires: null, templateFile: 'master-format.xlsx' },
    { key: 'country', label: 'Countries', requires: null, templateFile: 'countries-format.xlsx' },
    // Rows without a country go under the default country, which the backend adds if missing.
    { key: 'state', label: 'States', requires: null, templateFile: 'states-format.xlsx' },
    { key: 'city', label: 'Cities', requires: 'states', templateFile: 'cities-format.xlsx' },
    { key: 'venue', label: 'Venues', requires: 'cities', templateFile: 'venues-format.xlsx' },
];

export const UPLOAD_FILE_PATTERN = /\.(xlsx|xls|csv)$/i;

// Preselected country when adding a state or city; the backend uses the same default.
export const DEFAULT_COUNTRY_NAME = 'India';
